import { Link, NavLink } from "react-router-dom";
import { useCustomer } from "../customer/CustomerContext";

const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
];

const CURRENCIES = [
  { code: "USD", label: "USD" },
  { code: "EUR", label: "EUR" },
  { code: "GBP", label: "GBP" },
];

function HeartIcon({ filled }: { filled?: boolean }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" className="header-tool-icon">
      <path
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="2"
        d="M12 21s-7-4.6-9.5-9A5.4 5.4 0 0 1 12 5.2 5.4 5.4 0 0 1 21.5 12C19 16.4 12 21 12 21z"
      />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" className="header-tool-icon">
      <circle cx="12" cy="8" r="3.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path
        d="M5 19.5c1.8-3.2 4.2-4.5 7-4.5s5.2 1.3 7 4.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function HeaderCustomerTools() {
  const { customer, language, currency, favorites, setLanguage, setCurrency, loading } =
    useCustomer();

  return (
    <div className="header-tools" aria-label="Account tools">
      <label className="header-tool">
        <span className="visually-hidden">Language</span>
        <select
          className="header-tool-select"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          aria-label="Language"
        >
          {LANGUAGES.map((l) => (
            <option key={l.code} value={l.code}>
              {l.label}
            </option>
          ))}
        </select>
      </label>

      <label className="header-tool">
        <span className="visually-hidden">Currency</span>
        <select
          className="header-tool-select"
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          aria-label="Currency"
        >
          {CURRENCIES.map((c) => (
            <option key={c.code} value={c.code}>
              {c.label}
            </option>
          ))}
        </select>
      </label>

      <NavLink
        to="/account/favorites"
        className={({ isActive }) =>
          `header-tool header-tool-btn${isActive ? " header-tool-btn--active" : ""}`
        }
        title="Favorites"
        aria-label={`Favorites${favorites.length ? ` (${favorites.length})` : ""}`}
      >
        <HeartIcon filled={favorites.length > 0} />
        {favorites.length > 0 ? (
          <span className="header-tool-badge">{favorites.length}</span>
        ) : null}
      </NavLink>

      {loading ? (
        <span className="header-tool header-tool-muted">…</span>
      ) : customer ? (
        <Link
          to="/account"
          className="header-tool header-tool-btn header-tool-account"
          title="My account"
        >
          <UserIcon />
          <span className="header-tool-label">
            {customer.first_name || customer.email.split("@")[0]}
          </span>
        </Link>
      ) : (
        <Link to="/account/login" className="header-tool header-tool-btn header-tool-account">
          <UserIcon />
          <span className="header-tool-label">Log in</span>
        </Link>
      )}
    </div>
  );
}
